import React from 'react'
import { Cell, Tabs, Tab } from 'react-mdl'
import './style.css'

import Item from '../item'

export default class EquippedItems extends React.Component {
    _items = [];

    state = {
        items: null,
        set_bonuses: [],
        expansion: false,
        swap: 0
    }

    constructor(props) {
        super(props);

        const items = props.data.items.map((item) => {
            let setBonuses = [];
            let setPartialBonuses = [];
            let setInfo = undefined;
            if (item.set_id !== undefined) {
                if (props.data.set_bonuses[0][item.set_id] !== undefined) {
                    setBonuses.push(props.data.set_bonuses[0][item.set_id]);
                } else {
                    setBonuses.push({});
                }
                if (props.data.set_bonuses[1][item.set_id] !== undefined) {
                    setBonuses.push(props.data.set_bonuses[1][item.set_id]);
                } else {
                    setBonuses.push({});
                }
                if (item.main_set_partial_bonuses !== undefined) {
                    setPartialBonuses[0] = item.main_set_partial_bonuses;
                } else {
                    setPartialBonuses[0] = [];
                }
                if (item.secondary_set_partial_bonuses !== undefined) {
                    setPartialBonuses[1] = item.secondary_set_partial_bonuses;
                } else {
                    setPartialBonuses[1] = [];
                }
                setInfo = props.data.setItems[item.set_id];
            }
            item.setBonuses = setBonuses;
            item.setPartialBonuses = setPartialBonuses;
            item.setInfo = setInfo;
            return item;
        });

        this.state = {
            items: items,
            set_bonuses: props.data.set_bonuses,
            expansion: props.data.expansion,
            swap: 0
        };
    }

    switchWeapons(tabId) {
        this.setState({ swap: tabId });
        this.props.handleSwitchWeapons(tabId);
        this._items.forEach(item => {
            item.handleSwitchWeapons(tabId);
        });
    }

    render() {
        return (
            <Cell className="equipped-tab" col={6} tablet={12} phone={12}>
                <div className={`equipped-items swap-index-${this.state.swap}`}>
                <Tabs className={`left-swap swap-tab expansion-${this.state.expansion}`}
                      activeTab={this.state.swap}
                      onChange={(tabId) => this.switchWeapons(tabId)} ripple>
                    <Tab>i</Tab>
                    <Tab>ii</Tab>
                </Tabs>
                <Tabs className={`right-swap swap-tab expansion-${this.state.expansion}`}
                      activeTab={this.state.swap}
                      onChange={(tabId) => this.switchWeapons(tabId)} ripple>
                    <Tab>i</Tab>
                    <Tab>ii</Tab>
                </Tabs>
                { this.state.items.map((item) =>
                    <Item key={(item.id)} data={item} activeWeaponTabId={this.state.swap} ref={(child) => { this._items.push(child); }}/>
                )}
                <div className="item-backdrop location-1"></div>
                <div className="item-backdrop location-2"></div>
                <div className="item-backdrop location-3"></div>
                <div className="item-backdrop location-4"></div>
                <div className="item-backdrop location-5"></div>
                <div className="item-backdrop location-6"></div>
                <div className="item-backdrop location-7"></div>
                <div className="item-backdrop location-8"></div>
                <div className="item-backdrop location-9"></div>
                <div className="item-backdrop location-10"></div>
                <div className="item-backdrop location-11"></div>
                <div className="item-backdrop location-12"></div>
                </div>
            </Cell>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/equipped-items/index.js